import { createEvent, createStore } from 'effector';

const SESSION_KEY = 'onboarding_isReturningUser';
const FLOW_COMPLETE_KEY = 'onboarding_isFlowComplete';

function readStoredIsReturningUser(): boolean | null {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (raw === 'true') return true;
    if (raw === 'false') return false;
    return null;
  } catch {
    return null;
  }
}

function writeStoredIsReturningUser(value: boolean | null) {
  try {
    if (value === null) sessionStorage.removeItem(SESSION_KEY);
    else sessionStorage.setItem(SESSION_KEY, String(value));
  } catch {
    // Ignore quota / private-mode failures — the store still works for the current page.
  }
}

function readStoredFlowComplete(): boolean {
  try {
    return sessionStorage.getItem(FLOW_COMPLETE_KEY) === 'true';
  } catch {
    return false;
  }
}

function writeStoredFlowComplete(value: boolean) {
  try {
    if (value) sessionStorage.setItem(FLOW_COMPLETE_KEY, 'true');
    else sessionStorage.removeItem(FLOW_COMPLETE_KEY);
  } catch {
    // Ignore quota / private-mode failures — the store still works for the current page.
  }
}

/** Persists the verified account type across refreshes within the current onboarding attempt. */
export const setIsReturningUser = createEvent<boolean | null>();
export const setIsFlowComplete = createEvent<boolean>();
export const resetOnboardingSession = createEvent();

export const onboardingSessionStore = createStore<{
  isFlowComplete: boolean;
  isReturningUser: boolean | null;
}>({
  isFlowComplete: readStoredFlowComplete(),
  isReturningUser: readStoredIsReturningUser(),
})
  .on(setIsReturningUser, (state, isReturningUser) => ({ ...state, isReturningUser }))
  .on(setIsFlowComplete, (state, isFlowComplete) => ({ ...state, isFlowComplete }))
  .on(resetOnboardingSession, () => ({ isFlowComplete: false, isReturningUser: null }));

setIsReturningUser.watch(writeStoredIsReturningUser);
setIsFlowComplete.watch(writeStoredFlowComplete);
resetOnboardingSession.watch(() => {
  writeStoredIsReturningUser(null);
  writeStoredFlowComplete(false);
});
